import React from "react";
import { FormattedMessage } from "react-intl";
import { IProps } from "./interfaces";
import messages from "./messages";

const ViewSharedLabel = ({ plan: { accepted, public: isPublic } }: IProps) =>
    accepted || isPublic
        ? (
            <FormattedMessage {...messages.viewListed} />
        )
        : (
            <FormattedMessage {...messages.viewShared} />
        );

export default ViewSharedLabel;
